export default "__VITE_PUBLIC_ASSET__059b0d3f__"